import {useCurrentRoute} from '~/CreateFabricInvitation/navigation';
import {useIsLargishAndUp} from '~/common/hooks/useMatchQuery';
import {EnvelopeProvider} from '../contexts/EnvelopeContext';
import {CardDesignNavigator} from './CardDesignNavigator/CardDesignNavigator';
import {NavBottom} from './NavBottom/NavBottom';

export const MobileBottomUI = () => {
  const isDesktop = useIsLargishAndUp();
  const currentRoute = useCurrentRoute();

  // We only want to show the bottom ui on step 1
  const showCtaNavBottom = currentRoute.id === 1 && !currentRoute.meta.editing;

  return (
    <EnvelopeProvider>
      <div className="card-design__nav-bottom__buttons_wrapper step4-mobile-card-design">
        <CardDesignNavigator />
        {!isDesktop && showCtaNavBottom && (
          <NavBottom allBackgroundsLoaded currentRoute={currentRoute} />
        )}
      </div>
    </EnvelopeProvider>
  );
};
